import WorkOrdersApi from '../../../../services/api/work-orders-api';
import { updateWorkOrder } from '../work-orders';
import {
  WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET,
  WORK_ORDERS_CREATION_WORKING_HOURS_INVALID,
  WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE,
  WORK_ORDERS_CREATION_WORKING_HOURS_SELECT,
  WORK_ORDERS_CREATION_WORKING_HOURS_VALID,
} from '../action-types';
import { showErrorMessage } from '../../../messages';
import { goToSummary } from './creation';

function validate(workingHours, other) {
  if (workingHours.filter((element) => element.selected).length === 0) {
    return 'Please select at least one element from the list.';
  }
  return null;
}

export function addWorkingHoursRequest(workOrderId, workingHours, other) {
  return (dispatch) => {
    const validation = validate(workingHours, other);
    if (validation !== null) {
      dispatch(invalidWorkingHour(validation));

      return null;
    } else {
      const newWorkingHours = workingHours
        .filter((element) => element.selected)
        .map((element) => {
          return element.value;
        });

      if (other !== '') {
        newWorkingHours.push(other);
      }

      dispatch(validWorkingHour());
      return WorkOrdersApi.addWorkingHours(workOrderId, newWorkingHours).then(
        (response) => {
          if (response.ok) {
            dispatch(updateWorkOrder(response.workOrder));
            dispatch(goToSummary());
          } else {
            dispatch(showErrorMessage(response.errors));
          }

          return response;
        }
      );
    }
  };
}

export function validWorkingHour() {
  return {
    type: WORK_ORDERS_CREATION_WORKING_HOURS_VALID,
  };
}

export function invalidWorkingHour(validation) {
  return {
    type: WORK_ORDERS_CREATION_WORKING_HOURS_INVALID,
    payload: validation,
  };
}

export function selectWorkingHour(id) {
  return {
    type: WORK_ORDERS_CREATION_WORKING_HOURS_SELECT,
    payload: id,
  };
}

export function changeOtherWorkingHour(value) {
  return {
    type: WORK_ORDERS_CREATION_WORKING_HOURS_OTHER_CHANGE,
    payload: value,
  };
}

export function setCurrentWorkingHours(currentWorkingHours) {
  return {
    type: WORK_ORDERS_CREATION_WORKING_HOURS_CURRENT_SET,
    payload: currentWorkingHours,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/creation/working-hours.js